module.exports = __webpack_public_path__ + "img/ico_noti_success.96a05624.svg";